/* eslint-disable max-lines-per-function */
import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router';

import { useAccessPermissions } from '@/hooks/useAccessPermissions';
import { useAuth } from '@/hooks/useAuth';

export const useRouteProtection = () => {
  const { user, profile, isLoaded: isAuthLoaded } = useAuth();
  const {
    isLoading: isAccessLoading,
    hasSubscription,
    hasActiveSubscription,
    hasOrganizationMembership,
  } = useAccessPermissions();

  const navigate = useNavigate();
  const location = useLocation();

  const needsOnboarding =
    profile &&
    !profile.onboarding_completed &&
    location.pathname !== '/onboarding';
  const isDataLoading = !isAuthLoaded || isAccessLoading;
  const lacksAccess = !hasActiveSubscription && !hasOrganizationMembership;
  const isOnAccountPage = location.pathname === '/account';
  const isOnOnboardingPage = location.pathname === '/onboarding';

  useEffect(() => {
    if (isDataLoading) {
      return;
    }

    if (!user) {
      navigate('/auth', { replace: true });
      return;
    }

    if (needsOnboarding) {
      navigate('/onboarding', { replace: true });
      return;
    }

    if (isOnOnboardingPage) {
      return;
    }

    if (isOnAccountPage) {
      return;
    }

    if (lacksAccess) {
      navigate('/account?section=subscription', { replace: true });
      return;
    }

    if (!hasOrganizationMembership && !hasSubscription) {
      navigate('/account?section=profile', { replace: true });
      return;
    }
  }, [
    user,
    isAuthLoaded,
    isAccessLoading,
    needsOnboarding,
    hasSubscription,
    hasOrganizationMembership,
    hasActiveSubscription,
    location.pathname,
    navigate,
  ]);

  return {
    isDataLoading,
    isOnAccountPage,
    shouldBlockContent:
      !user ||
      needsOnboarding ||
      (lacksAccess && !isOnAccountPage && !isOnOnboardingPage),
  };
};
